import { ScrollableContent } from "@homebound/beam";
import { HistoryFeed } from "src/components";
import { useItemEditorHistoryQuery } from "src/routes/admin/items/ItemEditorHistoryTab.generated";
import { queryResult } from "src/utils";

export function ItemEditorHistoryTab({ itemId }: { itemId: string }) {
  const query = useItemEditorHistoryQuery({ variables: { itemId } });
  return queryResult(query, {
    data: ({ items }) => (
      <ScrollableContent>
        <HistoryFeed historyItems={items.first?.history ?? []} />
      </ScrollableContent>
    ),
  });
}
